import React from "react";
import { usePagination } from "../../../utilities/hookutils";
import { NoDataAvailableDiv } from "../../../components/NoDataAvailableDiv";
import Panel from "../../../components/panels/panel";
import Filters, { type FilterState, allStates } from "./Filters";
import StripePaymentIntentRowCard from "./StripePaymentIntentCard";

const perPage = 5;
const initialFilterState = allStates.filter(s => s.key === "failed")[0];

const StripePaymentIntentList = () => {
  const [stripePaymentIntents, setStripePaymentIntents] = React.useState<server.dto.StripePaymentIntent[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [filters, setFilters] = React.useState<FilterState>(initialFilterState);

  const paginate = async (paginationData: Partial<server.dto.PaginationData>) => {
    const res = await window.CoreApi.Stripe.ListStripePaymentProblem({ page: paginationData.page, perPage, states: filters.states });
    setStripePaymentIntents(res.data.data);
    setIsLoading(false);

    return res.data.pagination;
  };

  React.useEffect(() => {
    paginate({ page: 1 });
  }, [filters]);

  const pagination = usePagination(perPage, paginate);

  const onRetryFinished = async (wasSuccessful: boolean) => {
    if (wasSuccessful) { pagination.onPaginate(pagination.page); }
  };

  return <Panel
    title="Stripe payment intents"
    isLoading={isLoading}
    panelClassName="s1_dashboard-panel"
    pagination={pagination.Component}
  >
    <Filters
      activeStateKey={filters.key}
      onStateChanged={setFilters}
    />
    {stripePaymentIntents.length > 0 && <div className="list-with-gaps gap-layout">
      <div className="list-with-gaps-body">
        {stripePaymentIntents.map((payment) =>
          <StripePaymentIntentRowCard
            payment={payment}
            key={payment.stripePaymentIntentId}
            onRetryFinished={onRetryFinished}
          />)}
      </div>
    </div>}
    {stripePaymentIntents.length === 0 && <NoDataAvailableDiv />}
  </Panel >;
};

export default StripePaymentIntentList;